<template>
	<!--Add more method names if Appendixs are from more than one section-->
	<div v-if="method == 'SearchStrings' || showAll">
		<h3>Appendix X - Search Strategies</h3>
		<p v-for="database of $tera.project.databases" :key="database.label">
			<b>
				{{ database.label }} - run {{ formatDate($tera.project.dateOfSearch) }}
			</b>
			<br />
			<br />
			<span style="white-space: pre-wrap;">{{
				getSearchString(database)
			}}</span>
		</p>

		<h3>Appendix Y - Search Strategies</h3>
		<p v-for="database of $tera.project.registries" :key="database.label">
			<b>
				{{ database.label }} - run
				{{ formatDate($tera.project.registryDateOfSearch) }}
			</b>
			<br />
			<br />
			<span style="white-space: pre-wrap;">{{ database.string }}</span>
		</p>
	</div>
</template>
<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputAppendix.vue",
	mixins: [OutputMixin],
	props: {
		method: String,
		showAll: Boolean
	},
	methods: {
		getSearchString(database) {
			return database.manualVersion; //return final Version
		}
	}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
